import { render, staticRenderFns } from "./clxx-view.vue?vue&type=template&id=3fce98cb&"
import script from "./clxx-view.vue?vue&type=script&lang=js&"
export * from "./clxx-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports